import config from "src/config";
import type { BranchError, SessionData } from "branch-sdk";

const initializeBranch = async () => {
  try {
    const branchSDK = (await import("branch-sdk")).default;

    // Initialize the branch SDK. Note that this could fail without throwing an
    // exception. If that happens, subsequent calls to branchSDK will fail (and
    // throw). Be aware of that possibility when calling functions on branchSDK.
    branchSDK.init(config.mobileTrampoline.branchSdkKey);

    return branchSDK;
  } catch (e) {
    console.error("[branch-sdk] Error in initializeBranch", e);

    throw e;
  }
};

export const getBranchData = async () => {
  try {
    const branchSDK = await initializeBranch();

    return await new Promise<SessionData | null>((resolve, reject) => {
      branchSDK.data(function (
        err: BranchError,
        data: SessionData | null
      ): void {
        if (err) {
          reject(err);
        } else {
          resolve(data);
        }
      });
    });
  } catch (e) {
    console.error("[branch-sdk] Error in getBranchData", e);
  }
};

export const getDeepLink = async ({
  campaign,
  cardId,
  cardUrl,
  contributorId,
}: {
  campaign: string;
  cardId?: string;
  cardUrl?: string;
  contributorId?: string;
}) => {
  try {
    const branchSDK = await initializeBranch();

    return await new Promise<string | null>((resolve, reject) => {
      branchSDK.link(
        { campaign, data: { cardId, cardUrl, contributorId } },
        function (err: BranchError, link: string | null): void {
          if (err) {
            reject(err);
          } else {
            resolve(link);
          }
        }
      );
    });
  } catch (e) {
    console.error("[branch-sdk] Error in getDeepLink", e);
  }
};
